import React, { useState, useEffect } from "react";
import axios from "../../../utils/cmsAxios";
import { useNavigate, useLocation } from "react-router-dom";
import ConfirmModal from "../CommonComponents/ConfirmModal";

const CmsFaqCreate = () => {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [tag, setTag] = useState("");
    const [customTag, setCustomTag] = useState("");
    const [tagList, setTagList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showCustomTagInput, setShowCustomTagInput] = useState(false);
    const navigate = useNavigate();

    const location = useLocation();
    const faq = location.state?.faq || null;

    const [openAlert, setOpenAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [openLeave, setOpenLeave] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);

    useEffect(() => {
        // 태그 목록 불러오기
        const fetchTags = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_FASTAPI_ADS_URL}/faq/tag`);
                const tags = (res.data || []).map(tag => tag.name); // 🔥 name만 추출
                setTagList(tags || []);
            } catch (err) {
                console.error("태그 불러오기 실패:", err);
            }
        };
        fetchTags();
    }, []);

    useEffect(() => {
        if (faq) {
            setTitle(faq.question);
            setContent(faq.answer);
            setTag(faq.category_name);  // 태그 이름 기준
        }
    }, [faq]);

    const handleTagChange = (e) => {
        const selected = e.target.value;
        if (selected === "__custom__") {
            setShowCustomTagInput(true);
            setTag("");  // 기존 선택 초기화
        } else {
            setTag(selected);
            setShowCustomTagInput(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const finalTag = showCustomTagInput ? customTag : tag;

        if (!title || !content || !finalTag) {
            setError("제목, 내용, 태그를 모두 입력해주세요.");
            return;
        }

        setLoading(true);

        try {
            if (faq) {
                const response = await axios.post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/faq/update`, {
                    faq_id: faq.faq_id,
                    question: title,
                    answer: content,
                    name: finalTag,
                });

                if (response.status === 201) {
                    // setError("FAQ 수정 성공.");
                    setAlertMsg("수정 되었습니다.");
                    setOpenAlert(true);
                }
            }
            else {
                const response = await axios.post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/faq/create`, {
                    question: title,
                    answer: content,
                    name: finalTag,
                });

                if (response.status === 201) {
                    // setError("FAQ 생성 성공.");
                    setAlertMsg("등록 되었습니다.");
                    setOpenAlert(true);
                }
            }

        } catch (error) {
            setError("FAQ 생성하는데 실패했습니다.");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleGoToList = () => navigate("/cms/faq");

    const confirmDelete = async () => {
        if (!faq) return;
        setOpenDelete(false);
        await handleDelete(faq.faq_id);
    };

    // 삭제
    const handleDelete = async (faq_id) => {
        // if (!window.confirm("정말 삭제하시겠습니까?")) return;

        try {
            const url = `${process.env.REACT_APP_FASTAPI_ADS_URL}/faq/delete`;
            const res = await axios.post(
                url,
                { faq_id },
                { headers: { "Content-Type": "application/json" } }
            );

            if (res.status === 201) {
                // alert("삭제되었습니다.")
                // handleGoToList();
                setAlertMsg("삭제 되었습니다.");
            } else {
                alert("FAQ 삭제 실패");
            }
            setOpenAlert(true);
        } catch (e) {
            console.error("FAQ 삭제 실패:", e);
            // alert("삭제 중 오류가 발생했습니다.");
            setOpenDelete(false);
            setError("삭제 중 오류가 발생했습니다.");
            setOpenAlert(true);
        }
    };

    return (
        <div className="min-h-screen bg-neutral-50">
            <div className="mx-auto max-w-[1280px] bg-white rounded-2xl shadow-[0_0_0_1px_rgba(0,0,0,0.06),0_40px_80px_-24px_rgba(0,0,0,0.12)] overflow-hidden">
                <div className="flex">
                    {/* Left Nav */}

                    {/* Right content */}
                    <div className="flex-1 min-w-0 bg-neutral-50/70">
                        {/* Top header */}

                        <main
                            className="pt-12 flex flex-col gap-4 p-8 overflow-x-hidden max-w-[650px]">
                            <div className="flex justify-between items-center pb-4">
                                <h2 className="text-xl font-semibold mb-3">
                                    <button
                                        onClick={handleGoToList}
                                        className="hover:underline focus:outline-none"
                                    >
                                        FAQ
                                    </button>
                                    {" >"} {faq ? "상세" : "등록"}
                                </h2>
                            </div>

                            {error && <div className="text-green-600 pb-4">{error}</div>}

                            <form onSubmit={handleSubmit} className="space-y-4">                                
                                <div>
                                    <label htmlFor="tag" className="block text-sm font-medium text-gray-700">카테고리</label>
                                    <select
                                        id="tag"
                                        value={tag}
                                        onChange={handleTagChange}
                                        className="block w-full p-2 border rounded-lg"
                                    >
                                        <option value="">카테고리를 선택하세요</option>
                                        {tagList.map((t) => (
                                            <option key={t} value={t}>{t}</option>
                                        ))}
                                        <option value="__custom__">카테고리 추가하기</option>
                                    </select>

                                    {showCustomTagInput && (
                                        <input
                                            type="text"
                                            placeholder="새 태그 입력"
                                            value={customTag}
                                            onChange={(e) => setCustomTag(e.target.value)}
                                            className="mt-2 block w-full p-2 border rounded-lg"
                                        />
                                    )}
                                </div>
                                
                                <div>
                                    <label htmlFor="title" className="block text-sm font-medium text-gray-700">질문</label>
                                    <input
                                        type="text"
                                        id="title"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                        className="block w-full p-2 border rounded-lg"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="content" className="block text-sm font-medium text-gray-700">답변</label>
                                    <textarea
                                        id="content"
                                        value={content}
                                        onChange={(e) => setContent(e.target.value)}
                                        rows="15"
                                        className="block w-full p-2 border rounded-lg"
                                    />
                                </div>


                                {/* 버튼 영역 */}
                                <div className="flex items-center gap-4 pt-4">
                                    <div className="flex-1" />
                                    <div className="flex gap-4">                                    
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="px-4 py-2 bg-violet-200 text-violet-600 rounded-lg disabled:opacity-50"
                                        >
                                            {loading ? "대기" : (faq ? "저장" : "등록")}
                                        </button>

                                        <button
                                            type="button"
                                            // onClick={handleGoToList}
                                            onClick={() => setOpenLeave(true)}
                                            className="px-4 py-2 bg-gray-200 text-gray-600 rounded-lg"
                                        >
                                            이전
                                        </button>
                                    </div>
                                
                                    <div className="flex-1 flex justify-end">
                                        {faq && (
                                            <button
                                                type="button"
                                                className="px-4 py-2 bg-gray-300 text-gray-600 rounded-lg"
                                                // onClick={(e) => { e.preventDefault(); handleDelete(faq.faq_id); }}
                                                onClick={(e) => { e.preventDefault(); setOpenDelete(true); }}
                                            >
                                                삭제
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </form>
                            {/* 알림 */}
                            <ConfirmModal
                                open={openAlert}
                                title=""
                                message={alertMsg || "처리가 완료되었습니다."}
                                onClose={() => {
                                    setOpenAlert(false);
                                    if (alertMsg && (alertMsg.includes("등록") || alertMsg.includes("수정") || alertMsg.includes("삭제"))) {
                                    handleGoToList();
                                    }
                                }}
                                buttons={[
                                    { label: "확인", intent: "primary", autoFocus: true, onClick: () => {
                                        setOpenAlert(false);
                                        if (alertMsg && (alertMsg.includes("등록") || alertMsg.includes("수정") || alertMsg.includes("삭제"))) {
                                        handleGoToList();
                                        }
                                    }}
                                ]}
                            />

                            {/* 이탈 확인 */}
                            <ConfirmModal
                                open={openLeave}
                                title="이전"
                                message="변경사항을 저장하지 않고 이전페이지로 이동하시겠습니까?"
                                onClose={() => setOpenLeave(false)}
                                buttons={[
                                    { label: "저장하지 않고 이동", onClick: () => { setOpenLeave(false); handleGoToList(); } },
                                    { label: "현 페이지에 머무르기", intent: "primary", autoFocus: true, onClick: () => setOpenLeave(false) },
                                ]}
                            />
                            <ConfirmModal
                                open={openDelete}
                                title="삭제"
                                message="해당 게시물을 삭제하시겠습니까?"
                                onClose={() => setOpenDelete(false)}
                                buttons={[
                                    { label: "삭제", intent: "primary", onClick: confirmDelete },
                                    { label: "취소", onClick: () => setOpenDelete(false) },
                                ]}
                            />
                        </main>
                    </div>
                </div>
            </div >
        </div >
    );
};

export default CmsFaqCreate;
